import { LitElement, html, css, nothing} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { VoyageStyle } from '../../local_modules/voyage-style/src/voyage-style';
import Player from '@meteogroup/player-core';
// Components
import { MapView, VoyageMap } from '../../local_modules/voyage-map/src/voyage-map';
import { VoyageInfo } from '../../local_modules/voyage-info/src/voyage-info';
import { SvgIcons } from '../../local_modules/voyage-svg-icons/src/voyage-svg-icons';

import '../../local_modules/voyage-map/src/voyage-map';
import '../../local_modules/voy-alert-messages/src/voy-alert-messages';
import '../../local_modules/voyage-button/src/voyage-button';
import '../../local_modules/voyage-drawer-panel/src/voyage-drawer-panel';
import '../../local_modules/voyage-float-panel/src/voyage-float-panel';
import '../../local_modules/voyage-loading-indicator/src/voyage-loading-indicator';
import '../../local_modules/voyage-login-overlay/src/voyage-login-overlay';
import '../../local_modules/voyage-performance-overview/src/voyage-performance-overview';
import '../../local_modules/voyage-tooltip/src/voyage-tooltip';
import '../../local_modules/fleet-session-expire-popup/fleet-session-expire-popup'
import '../../local_modules/voyage-topbar/src/voyage-topbar';
import '../../local_modules/voyage-toggle-box/src/voyage-toggle-box';
import '../../local_modules/voyage-info/src/voyage-info';
import '../../local_modules/voyage-weather-control/src/voyage-weather-control';
import '../../local_modules/voyage-time-control/src/voyage-time-control';
import '../../local_modules/voy-chart-depths-control/src/voy-chart-depths-control';
import '../../local_modules/voy-fleet-sub-view/src/voy-fleet-sub-view-container';
import '../../local_modules/port-memo-popup/src/port-memo-popup';
import '../../local_modules/voyage-weather-alarm/src/voy-weather-alarm-popup';
import '../../local_modules/voy-global-filters/src/voy-global-filters';
import "../../local_modules/vessel-map-layers-selector/src/shore-map-layers-selector"
import '../../local_modules/voy-global-search/src/voy-global-search';
import '../../local_modules/voyage-heavy-weather-alarm-limits/src/voyage-heavy-weather-alarm-limits';
import '../../local_modules/voyage-map-view-options/src/voyage-map-view-options';
import '../../local_modules/voy-offline-vessels-popup/voy-offline-vessels-popup';

import { AuthorizationRoles, AuthService } from '../../src/services/auth-service';

import { ServiceWorkerReg } from '../../src/utils/reg-sw';

import { TraceService, setTraceService, EVENT_CATEGORIES } from '../../src/services/trace-service';
import { TraceServiceGA } from '../../src/services/trace-service-ga';

// Models
import { MgLayers, setMgLayers } from '../../src/maplayers/mg-layers';
import { MgLayersImpl } from '../../src/maplayers/mg-layers-impl';
import { PlanningLayers } from '../../src/maplayers/planning-layers';
import { ProgressModel, setProgressModel } from '../../src/models/progress-model';
import { ProgressModelImpl } from '../../src/models/progress-model-impl';
import { TerminalsModelImpl } from '../../src/models/terminals-model-impl';
import { setTerminalsModel, TerminalsModel } from '../../src/models/terminals-model';
import { UiStateModelImpl } from '../../src/models/ui-state-model-impl';
import { setUiStateModel, UiElements, UiStateModel, UiStateModelParam } from '../../src/models/ui-state-model';
import { VesselsModelImpl } from '../../src/models/vessels-model-impl';
import { VesselsModel, setVesselsModel } from '../../src/models/vessels-model';
import { VesselsTrackingModelImpl } from '../../src/models/vessels-tracking-model-impl';
import { VesselsTrackingModel, setVesselsTrackingModel } from '../../src/models/vessels-tracking-model';
import { PlanLayer } from '../../src/maplayers/plan-layer';
import { VesselInTimeLayers } from '../../src/maplayers/vessel-in-time-layers';
import { VoyageLayers } from '../../src/maplayers/voyage-layers';
import { VoyagePerformanceModelImpl } from '../../src/models/voyage-performance-model-impl';
import { setVoyagePerformanceModel } from '../../src/models/voyage-performance-model';
import { VoyagePlansModelImpl } from '../../src/models/voyage-plans-model-impl';
import { setVoyagePlansModel } from '../../src/models/voyage-plans-model';
import { setVoyageRoutingModel, VoyageRoutingModel } from '../../src/models/voyage-routing-model';
import { VoyageRoutingModelImpl } from '../../src/models/voyage-routing-model-impl';
import { VoyageSchedulesModelImpl } from '../../src/models/voyage-schedules-model-impl';
import { setVoyageSchedulesModel, VoyageSchedulesModel } from '../../src/models/voyage-schedules-model';
import { setVesselAlertsModel } from '../../src/models/vessel-alerts-model';
import { VesselAlertsModelImpl } from '../../src/models/vessel-alerts-model-impl';
import { setWeatherModel, WeatherModel } from '../../src/models/weather-model';
import { WeatherModelImpl } from '../../src/models/weather-model-impl';
import { PortAndTerminalLayer } from '../../src/maplayers/port-terminal-layer';
import { NearestPortEvents, NearestPortHighlights, NearestPortModel, NearestPortPosition, setNearestPortModel } from '../../src/models/nearest-port-model';
import { RestrictedAreasModelImpl } from '../../src/models/restricted-areas-model-impl';
import { setRestrictedAreasModel } from '../../src/models/restricted-areas-model';
import { TerminalGeofencesModelImpl } from '../../src/models/terminal-geofences-model-impl';
import { setTerminalGeoFencesModel } from '../../src/models/terminal-geofences-model';

/*START.DEV_ONLY*/
import '../../local_modules/voyage-routing-tester/src/voyage-routing-tester';
import { DevLayers } from '../../src/maplayers/dev-layers';
import { TraceServiceConsole } from '../../src/services/trace-service-console';
/*END.DEV_ONLY*/

import { TimeController } from '../../src/utils/time-controller';
import { VoyageDialogPopupManager } from '../../local_modules/voyage-dialog-popup/src/voyage-dialog-popup-manager';
import { verifyProtocol } from '../../src/utils/protocol-warning';
import { VoyageShoreContextModel, setVoyageShoreContextModel } from '../../src/models/voyage-shore-context-model';
import { VoyageShoreContextModelImpl } from '../../src/models/voyage-shore-context-model-impl';
import { VoyFleetAlarmModel, setVoyFleetAlarmModel } from '../../src/models/voy-fleet-alarm-model';
import { VoyFleetAlarmModelImpl } from '../../src/models/voy-fleet-alarm-model-impl';
import { VoyFleetNotificationModel, setVoyFleetNotificationModel } from '../../src/models/voy-fleet-notification-model'
import { VoyFleetNotificationModelImpl } from '../../src/models/voy-fleet-notification-model-impl';
import { setVoyagePastTrailModel } from '../../src/models/voyage-past-trail-model';
import { VoyagePastTrailModelImpl } from '../../src/models/voyage-past-trail-model-impl';
import { RulerLayer, RulerUpdateDetails } from '../../src/maplayers/ruler-layer';
import { NearestPortModelImpl } from '../../src/models/nearest-port-model-impl';

import * as OLExtent from 'ol/extent';
import { fromLonLat, toLonLat } from 'ol/proj';
import { RestrictedAreasLayer } from '../../src/maplayers/restricted-areas-layer';
import { setVoyMapModel, VoyMapModel } from '../../src/models/voy-map-model';
import { VoyMapModelImpl } from '../../src/models/voy-map-model-impl';
import { setPortViewModel } from '../../src/models/port-view-model';
import { PortViewModelImpl } from '../../src/models/port-view-model-impl';
import { EcaSecaLayer } from '../../src/maplayers/eca-seca-layer';
import { ShoreLayers } from '../../local_modules/vessel-map-layers-selector/src/shore-map-layers-selector';
import { setEcaSecaMarpolModel } from '../../src/models/eca-seca-marpol-zones-model';
import { EcaSecaMarpolModelImpl } from '../../src/models/eca-seca-marpol-zones-model-impl';
import { setWhaleZonesModel } from '../../src/models/whale-zones-model';
import { WhaleZonesModelImpl } from '../../src/models/whale-zones-model-impl';
import { WhaleZonesLayerAll } from '../../src/maplayers/whale-zones-layer-all';
import { ShoreWhaleZonesLayerInForce } from '../../src/maplayers/shore-whale-zones-layer-in-force';
import { setSecurityZonesModel } from '../../src/models/security-zones-model';
import { SecurityZonesModelImpl } from '../../src/models/security-zones-model-impl';
import { SecurityZonesLayer } from '../../src/maplayers/security-zones-layer';
import { TerminalGeofenceLayer } from '../../src/maplayers/terminal-geofence-layer';
import { authFetchGET } from '../../src/utils/auth-fetch';
import { elementCloseManager } from '../../src/utils/element-close-manager';
import { setDbModel } from '../../src/models/db-model';
import { DbModelImpl } from '../../src/models/db-model-impl';
import { MarpolLayer } from '../../src/maplayers/marpol-layer';
import { VoyWeatherBroadcastDrawer } from '../../local_modules/voy-weather-broadcast-drawer/src/voy-weather-broadcast-drawer';
import { VoyWeatherBroadcastManager } from '../../local_modules/voy-weather-broadcast-drawer/src/voy-weather-brodcast-manager';
import { ShoreContextEvent } from '../../src/models/types/voyage-shore-context-model.types';
import "../../local_modules/voy-weather-broadcast-drawer/src/voy-weather-broadcast-drawer";
import '../../local_modules/voyage-distance-deviation-overview/src/voyage-distance-deviation-overview';
import "../../local_modules/fleet-feedback/src/fleet-feedback-feature"
import "../../local_modules/acitivity-log/activity-log";
import "../../local_modules/voy-feature-add-notes/voy-feature-add-notes";
import "../../local_modules/voy-feature-view-notes/voy-feature-view-notes";
import "../../local_modules/voy-toast/src/voy-toast";
import { AlarmEvents, FilterEvents, FleetAlarm } from '../../src/models/types/voy-fleet-alarm-model.types';
import { OSM } from 'ol/source';
import { Tile, Vector } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { UserConfigService } from '../../src/services/user-config-services';
import { Alarm } from '../../src/services/types/fleet-alarms-service.types';
import { showHandleAlarm } from '../../src/utils/alarm-utils';
import { Vector as SourceVector } from 'ol/source';
import {GeoJSON} from 'ol/format'
import { Fill, Stroke, Style, Text } from 'ol/style';
import '../../local_modules/voy-global-filters/src/custom-filter-popup';
import { DEFAULT_PLAYBACK, getFormattedDateUTC } from '../../src/utils/helpers';
import { VoyageTimeControl } from '../../local_modules/voyage-time-control/src/voyage-time-control';
import { FilterUtils } from '../../local_modules/voy-global-filters/src/filter-utils';
import { AuditLog, WeatherRoutingNotificationEvents } from '../../src/services/types/fleet-weather-routing-notification.types';
import '../../local_modules/voyage-heavy-weather-alarm-limits/src/voyage-custom-weather-limits'
const _PROJECTION = (<any>window)["appenv"].projection;

interface VersionId {
    version: string;
}

@customElement('main-app')
export class MainApp extends LitElement {
    _showFeedback: boolean = false;
    showCloseIcon: boolean = false;
    @property({ attribute: false }) private customFilterOpened: boolean = false;
    constructor() {
        super();
        this.handleShowFeedback = this.handleShowFeedback.bind(this); 
        this._updateNearestPortHighlight = this._updateNearestPortHighlight.bind(this);
        this._nearestPortDropPin = this._nearestPortDropPin.bind(this);
        this._nearestPortRulerUpdate = this._nearestPortRulerUpdate.bind(this);
        this._showPortMemo = this._showPortMemo.bind(this);
        this._checkVersionId = this._checkVersionId.bind(this);
        this._onMapLayerSelectorClick = this._onMapLayerSelectorClick.bind(this);
        this._onWeatherClick = this._onWeatherClick.bind(this);
        this._onRouteTesterClick = this._onRouteTesterClick.bind(this);
        this._onGlobalFiltersClick = this._onGlobalFiltersClick.bind(this);
        this._updateNumberOfActiveFilters = this._updateNumberOfActiveFilters.bind(this);
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        this._togglePanelView = this._togglePanelView.bind(this);
        this._openFeedBackPopup = this._openFeedBackPopup.bind(this)
        this._resetMap = this._resetMap.bind(this);
        this._onMapViewSelectionChanged = this._onMapViewSelectionChanged.bind(this);
        this._onMapViewSelectionChangedEvent = this._onMapViewSelectionChangedEvent.bind(this);
        this._getMapConfig = this._getMapConfig.bind(this);
        this._onMapViewOptionsClick = this._onMapViewOptionsClick.bind(this);
        this.hideVesselLoader = this.hideVesselLoader.bind(this);
        this._checkForWeatherAlarms = this._checkForWeatherAlarms.bind(this);
        this._CheckForMoreAlarms = this._CheckForMoreAlarms.bind(this);
        this.onZoomLevelChanged = this.onZoomLevelChanged.bind(this);
        this.handleZoomLevelChanged = this.handleZoomLevelChanged.bind(this);
        this.handleWeatherToggle = this.handleWeatherToggle.bind(this);
        this._openCustomFilterPopup = this._openCustomFilterPopup.bind(this);
        this._closeCustomFilterPopup = this._closeCustomFilterPopup.bind(this);
        this._handleFilterSaved = this._handleFilterSaved.bind(this);
        this.handleLoaderToggle = this.handleLoaderToggle.bind(this);
        this.handlePastSimulationLimit = this.handlePastSimulationLimit.bind(this);
        this.togglePlayerControls = this.togglePlayerControls.bind(this);
        this.showForecastWarning = this.showForecastWarning.bind(this);
        this.acceptForecastWarning = this.acceptForecastWarning.bind(this);
        this.handleVesselsUpdated = this.handleVesselsUpdated.bind(this);
         verifyProtocol();

        const trackingId = (<any>window)["appenv"].services.traceservice.gaTrackingId;
        setTraceService(trackingId ? new TraceServiceGA() : new TraceServiceConsole());

        TraceService!.pageView(window.location.pathname);

        this._playerCore = new TimeController({
            startTime: Date.now(),
            playbackRate: DEFAULT_PLAYBACK,
        }).player;

        this.clearSessionStorage(['alarms_updated_at', 'positions_updated_at']);

        setDbModel(new DbModelImpl());
        setUiStateModel(new UiStateModelImpl());
        setProgressModel(new ProgressModelImpl());
        setVoyageRoutingModel(new VoyageRoutingModelImpl());
        setVesselAlertsModel(new VesselAlertsModelImpl());
        setVoyFleetAlarmModel(new VoyFleetAlarmModelImpl());
        setWeatherModel(new WeatherModelImpl(this._playerCore));
        setVoyageSchedulesModel(new VoyageSchedulesModelImpl());
        setVoyagePerformanceModel(new VoyagePerformanceModelImpl());
        setVoyagePlansModel(new VoyagePlansModelImpl());
        setVesselsTrackingModel(new VesselsTrackingModelImpl());
        setVesselsModel(new VesselsModelImpl());
        setVoyFleetNotificationModel(new VoyFleetNotificationModelImpl());
        setNearestPortModel(new NearestPortModelImpl());
        setTerminalsModel(new TerminalsModelImpl());
        setRestrictedAreasModel(new RestrictedAreasModelImpl());
        setVoyMapModel(new VoyMapModelImpl());
        setPortViewModel(new PortViewModelImpl());
        setEcaSecaMarpolModel(new EcaSecaMarpolModelImpl());
        setWhaleZonesModel(new WhaleZonesModelImpl());
        setSecurityZonesModel(new SecurityZonesModelImpl());
        setTerminalGeoFencesModel(new TerminalGeofencesModelImpl());

        // The other models needs to be initiated before the shore context model as it depends on them
        setVoyageShoreContextModel(new VoyageShoreContextModelImpl());

        setMgLayers(new MgLayersImpl(this._playerCore));

        this.onVesselSelected = this.onVesselSelected.bind(this);

        // Register Service Worker and listen for updates available.
        this._updateAvailable = false;
        if (!(<any>window).Cypress) {
            ServiceWorkerReg.register();    
        }

        VoyageRoutingModel!.addEventListener("calculation-failed", <EventListener>((evt: CustomEvent) => {
            VoyageDialogPopupManager.createDialog({
                headerText: "Error Calculating Route",
                bodyText: "There was an error calculating your route.\nPlease try again.",
                errorDetails: evt.detail.error,
                isError: true
            });
        }));

        this._checkVersionId();
        setInterval(() => this._checkVersionId(), 5*60*1000); // check for new version every 5 min
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.VesselsChange,()=>this._updateVesselsCount())
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle,()=>this._toggleTimeLine());
        this._openFeedBackPopup();
        UiStateModel!.addEventListener("panel-visibility", <EventListener>((evt: CustomEvent) => {
                this._togglePanelView(evt.detail.visible)
            }));
        UiStateModel!.addEventListener("set-anchor", <EventListener>((evt: CustomEvent) => {
                this._anchored = evt.detail.showAnchor
            }));
            UiStateModel!.addEventListener("show-focus-panel", <EventListener>((evt: CustomEvent) => {
                this._showFocus = evt.detail.showFocus
                this.requestUpdate()
            }));

            ProgressModel?.addEventListener('target-actions-changed', <EventListener>((evt: CustomEvent) => {
                this.togglePlayerControls(new CustomEvent("", {detail: {disable: true}}));
            }));
            ProgressModel?.addEventListener('action-completed', <EventListener>((evt: CustomEvent) => {
                let actions = ProgressModel?.getTargetActions('vessel-' + UiStateModel?.getValue(UiStateModelParam.IMO));
                if(!actions?.pending.length){
                    this.togglePlayerControls(new CustomEvent("", {detail: {disable: false}}));
                }
            }));
            

        AuthService.getCurrentUser()
    }

    clearSessionStorage(keys: string[]){
        keys.forEach((key: string) => {
            sessionStorage.removeItem(key);
        })
    }
     
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('show-feedback', this.handleShowFeedback);
        this.addEventListener('show-activity-log', this._handleShowActivityLog);
        this.addEventListener('show-add-note-popup', this._handleShowAddNotePopup);
        this.addEventListener('show-view-note-popup', this._handleShowViewNotePopup);
        this.addEventListener('open-custom-limits',  <EventListener>((evt: CustomEvent) => {this._openCustomLimits(evt)}));
        VesselsModel!.addEventListener('vessels-loaded', this.hideVesselLoader);
        VesselsModel!.addEventListener('vessels-updated', this.handleVesselsUpdated);
        VoyFleetAlarmModel?.addEventListener(AlarmEvents.AlarmsUpdated, this._checkForWeatherAlarms);
        VesselsTrackingModel!.addEventListener('positions-updated', this._checkForWeatherAlarms);
        MgLayers?.addEventListener('zoom-level-changed', <EventListener>this.onZoomLevelChanged)
        this.addEventListener('open-custom-filter', this._openCustomFilterPopup);
        WeatherModel!.addEventListener('show-forecast-warning', this.showForecastWarning);
        this.addEventListener(FilterEvents.FilterSaved, this._handleFilterSaved as EventListener);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('show-feedback', this.handleShowFeedback);
        this.removeEventListener('show-activity-log', this._handleShowActivityLog);
        this.removeEventListener('show-add-note-popup', this._handleShowAddNotePopup);
        this.removeEventListener('show-view-note-popup', this._handleShowViewNotePopup);
        this.removeEventListener('open-custom-limits',  <EventListener>this._openCustomLimits);
        VesselsModel!.addEventListener('vessels-loaded', this.hideVesselLoader);
        VesselsModel!.addEventListener('vessels-updated', this.handleVesselsUpdated);

        VoyFleetAlarmModel?.addEventListener(AlarmEvents.AlarmsUpdated, this._checkForWeatherAlarms);
        VesselsTrackingModel!.addEventListener('positions-updated', this._checkForWeatherAlarms);

        MgLayers?.removeEventListener('zoom-level-changed', <EventListener>this.onZoomLevelChanged)
        this.removeEventListener('open-custom-filter', this._openCustomFilterPopup);
        WeatherModel!.removeEventListener('show-forecast-warning', this.showForecastWarning);
        this.removeEventListener(FilterEvents.FilterSaved, this._handleFilterSaved as EventListener);
    }

    onZoomLevelChanged(evt: CustomEvent){
        this.handleZoomLevelChanged(evt.detail.zoom);
    }

    handleZoomLevelChanged(zoom: number){
        if(UiStateModel!.getValue(UiStateModelParam.SelecteMapView) === 'simplified'){
            return;
        }
        if((this.currentZoom > 6 && zoom > 6) || (this.currentZoom <= 6 && zoom <= 6)){
            this.currentZoom = zoom;
            return;
        }
        this.currentZoom = zoom;
        var vectorStroke = new Vector({
            source: new SourceVector({
                format: new GeoJSON(),
                url: "./countries.geojson"
            }),
             style: function(feature, res){
                return new Style({
                    stroke: new Stroke({
                        color: 'rgba(0, 0, 0, 1.0)',
                        width: 1
                    }),
                    text: new Text({
                        text: feature.get('name'),
                        font: '12px Calibri,sans-serif',
                        overflow: true,
                        fill: new Fill({
                            color: '#000'
                        }),
                        stroke: new Stroke({
                            color: '#fff',
                            width: 3
                        })
                    })
                });
             }
        });
        var vector = new Vector({
            source: new SourceVector({
                format: new GeoJSON(),
                url: "./countries.geojson"
            }),
             style: function(feature, res){
                return new Style({
                    text: new Text({
                        text: feature.get('name'),
                        font: '12px Calibri,sans-serif',
                        overflow: true,
                        fill: new Fill({
                            color: '#000'
                        }),
                        stroke: new Stroke({
                            color: '#fff',
                            width: 3
                        })
                    })
                });
             }
        });
        vectorStroke.set('name', 'flag_vectorStroke');
        vector.set('name', 'flag_vector');
        this._mapElement?.getMap()?.getLayers()?.forEach(layer => {
            if (layer?.get('name') && ['flag_vectorStroke','flag_vector'].includes(layer?.get('name'))){
                this._mapElement?.getMap()?.removeLayer(layer);
            }
        });
        if(zoom  > 6){
            this._mapElement?.getMap()?.addLayer(vector);
        }else{
            this._mapElement?.getMap()?.addLayer(vectorStroke);
        }
    }

    handleWeatherToggle(){
        this.showAdvancedWeather = !this.showAdvancedWeather;
        localStorage.setItem("showAdvancedWeather", this.showAdvancedWeather ? "true" : "false");

    }

    hideVesselLoader(){
        this._showVesselLoader = false;
        this.currentZoom = 4;
        this.handleZoomLevelChanged(this._mapElement?.getMap()?.getView()?.getZoom() ?? this.currentZoom);
    }

    private handleShowFeedback() {
        this._showFeedback = true;
        this.showCloseIcon = true;
        this.requestUpdate();
    }
   private _handleShowActivityLog(){
        this._showActivityLog = !this._showActivityLog;
        this.requestUpdate();
        VoyFleetAlarmModel!._fetchAlarmsForNotificationSender();  
        if(this._showActivityLog){
            VoyFleetNotificationModel?.dispatchEvent(new Event(WeatherRoutingNotificationEvents.FETCHALL));
        }
    }
    private _handleShowAddNotePopup(event: any){
        this._showActivityLog = false;
        this._showAddNotePopup = true;
        if(event.detail.isAuditLog)
            this._selectedAuditLogForNote = event.detail.selectedAlarm;
        else
            this._selectedAlarmForNote = event.detail.selectedAlarm;
        this.requestUpdate();
    }
    private _handleShowViewNotePopup(event: any){
        this._showActivityLog = false;
        this._showViewNotePopup = true;
        if(event.detail.isAuditLog)
            this._selectedAuditLogForNote = event.detail.selectedAlarm;
        else
            this._selectedAlarmForNote = event.detail.selectedAlarm;
        this.requestUpdate();
    }
    static get styles() {
        return [
            css`
                :host {
                    margin: 0;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    position: fixed;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    left: 0;
                    overflow: auto;
                    -webkit-scrollbar {
                        display: none; /* for Webkit browsers */
                    }
                    scrollbar-width: none; /* for Firefox */
                    -ms-overflow-style: none; /* for IE 10+ */
                }
                .main {
                    width: 100%;
                    flex-grow: 1;
                    position:relative;
                    z-index:1;
                }

                voyage-topbar {
                    z-index: 4;
                }

                voyage-map {
                    width: 100%;
                    height: 100%;
                }

                voy-global-search {
                    position: fixed;
                    top: 49px;
                    width: 324px;
                    display: block;
                    z-index: 4;
                }

                .loading-indicator-container {
                    position: fixed;
                    left: 0;
                    right: 0;
                    bottom: 56px;

                    display: flex;
                    justify-content: center;
                }

                voyage-player-controls {
                    width: 100%;
                    height: 56px;
                    position:fixed;
                    bottom:0;
                    left:0;
                    z-index: 1000;
                }

                voyage-button {
                    fill: var(--neutrals-grey-04, grey);
                    font-family: var(--component-heading-ff, 'serif');
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: normal;
                    height: 32px;
                }

                voyage-button > span {
                    color: var(--neutrals-grey-03, black);
                }

                voyage-button > svg {
                    height: 14px;
                }

                voyage-button .map-layers {
                    margin-left: 0px;
                }

                .panel-button-row {
                    position: fixed;
                    top: 64px;
                    right: 16px;
                    left: 370px;

                    display: flex;
                    align-items: flex-start;
                }

                .panel-button-row voyage-button {
                    margin-left: 10px;
                }

                .alerts-container {
                    flex-grow: 1;
                }

                .timecontrol {
                    z-index: 3;
                    width: 100%;
                    height: 56px;
                }

                .info-content {
                    width: 175px;
                    height: auto;
                }

                .refresh {
                    position: absolute;
                    right: 60px;
                    bottom: 60px;
                    background: var(--primary-blue-05, blue);
                    color: var(--neutrals-grey-10, white);
                    border-radius: 3px;
                    padding: 5px;
                    height: 20px;

                    text-align: center;
                    font-family: var(--component-paragraph-ff, 'serif');
                    font-size: var(--component-paragraph-size, 14px);
                    line-height: var(--component-paragraph-height, 20px);
                    font-weight: var(--component-paragraph-weight, normal);

                    animation-name: flash;
                    animation-duration: 3s;
                    animation-timing-function: linear;
                    animation-iteration-count: infinite;

                    cursor: pointer;
                }
                .right-panel-container {  
                    position: fixed;
                    top: 106px;
                    display: block;
                    overflow: hidden;
                    background-color: transparent;
                    z-index: 3;
                    font-family: var(--component-paragraph-ff);
                    min-height: 100vh;
                    min-width: 25px;
                }

                .refresh svg {
                    height: 14px;
                    fill: currentColor;
                }

                @keyframes flash {
                    0% { opacity: 1.0; }
                    50% { opacity: 0.3; }
                    100% { opacity: 1.0; }
                }
                voyage-drawer-panel {
                    width: 300px;
                }

                .performance-overview {
                    width: auto;
                    height: fit-content;
                }

                .activity-log {
                    width: auto;
                    margin-top: -63px;
                }
                .spinner{
                    position: fixed;
                    left: 50%;
                    top: 50px;
                    background-color: rgba(255,255,255,0.8);
                    margin: 0;
                    padding: 16px;
                }
                .forecast-heading{
                    font-size: 18px;
                    font-family: MaerskText;
                    font-weight: 700;
                }
                .forecast-heading-date{
                    font-size: 16px;
                    font-family: MaerskText;
                    font-weight: 400;
                }
                .forecast-message {
                    font-size: 13px;
                    font-family: MaerskText;
                    font-weight: 400;
                }
                .summary-header{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-right: 10px;
                    font-family: 'Maersk Text';
                    font-size: 17px;
                    color: #141414;
                    padding: 15px;

                    .heading{
                        font-weight: 700;
                    }
                    .sub-heading{
                        font-weight: 500;
                    }
                    .text-link{
                        font-weight: 500;
                        color: #0073AB;
                    }
                    .export-icon{
                        cursor: pointer;
                    }
                   
                }
                  .weather-limits-overlay {
                        position: fixed;
                        top: 45px;
                        border-top: 1px solid var(--neutrals-grey-06, black);
                        width: 100vw;
                        height: calc(100vh - 45px);
                        display: flex;
                        background-color: white;
                        z-index: 1000;
                        overflow-y: auto;
                        overflow-x: hidden;
                    }

                        .weather-limits-container {
                        font-family: MaerskText;
                        color: var(--neutrals-grey-03, black);
                        padding: 16px;
                        background: white;
                    }
            `
        ];
    }

    handleVesselsUpdated(){
        if(!this._vesselsUpdated){
            this._vesselsUpdated = true;
            this._checkForWeatherAlarms();
        }
    }

    private async _checkForWeatherAlarms() {
        const alarmsUpdatedAt = sessionStorage.getItem("alarms_updated_at");
        const positionsUpdatedAt = sessionStorage.getItem("positions_updated_at");
        if(alarmsUpdatedAt && positionsUpdatedAt && this._vesselsUpdated){
            const weatherAlarms = VoyFleetAlarmModel!.getWeatherAlarms;
            this._weatherAlarms = weatherAlarms;
            if(this._weatherAlarms.length) {
                this._alarm = this._weatherAlarms[0];
                this.isAlarmPopupOpen = true;
                this.alarmsCount = this._weatherAlarms.length;
            }
            this.requestUpdate();
                const alarmsTimestamp = new Date(JSON.parse(alarmsUpdatedAt));
                const positionsTimestamp = new Date(JSON.parse(positionsUpdatedAt));
                if(alarmsTimestamp > positionsTimestamp){
                    VesselsTrackingModel?._processVessels();
                }
        }
    }

    
    tracingAnalyticsOnClick(elementName: string) {
        TraceService!.event(EVENT_CATEGORIES.SHORE_MAIN_APP, 'click', elementName)
    }

   private handleClose() {
            this._showFeedback = false;
            this.showCloseIcon = false;
            this.requestUpdate()
    }
   private handleCloseAddNote(){   
    this._showAddNotePopup = false;
    this._selectedAlarmForNote = null;
    this._selectedAuditLogForNote = null;
   }  
   private handleCloseViewNote(){
    this._showViewNotePopup = false;
    this._selectedAlarmForNote = null;
    this._selectedAuditLogForNote = null;
   }

    @property({type: Boolean}) isAlarmPopupOpen = true;
    @property({type: Object}) _alarm: Alarm|undefined;
    @property ({type: Number}) alarmsCount = 0;

    private _CheckForMoreAlarms(alarms: Alarm[]) {
		if (alarms.length) {
			this.isAlarmPopupOpen = true;
			this._alarm = alarms[0];
		} else {
            this.isAlarmPopupOpen = false;
        }
		this.alarmsCount = VoyFleetAlarmModel!.getWeatherAlarms?.length ?? 0;
	}
    @property({ attribute: false }) filterResult?: string;
    @property({ attribute: false }) triggered:boolean = false;

        
    private handleCloseFilter(){

        this.filterResult = FilterUtils.filterToString({ commands:[], text: []});
        UiStateModel!.setValue(UiStateModelParam.FISubView);
        UiStateModel!.setValue('q', this.filterResult);

        this.dispatchEvent(new CustomEvent("filters-changed", {
            detail: {
                numberOfActiveFilters: 0,
                numberOfVessels: 0
            }
        })) 
        VoyageShoreContextModel!.setClearFilters();
        this.triggered = !this.triggered;
    }
    render() {
        const globalFiltersTitle =
          this._numberOfActiveFilters > 0
            ? `Filters (${this._numberOfActiveFilters})`
            : "Filters";
        this.alarmsCount = VoyFleetAlarmModel!.getWeatherAlarms?.length ?? 0;
        
        return html`
            <voyage-topbar app-name="Fleet Voyage"
                           @show-depths-control=${ () => this._showDepthsControl = true }>
            </voyage-topbar>
            <div class="main">
                 ${this._showHeavyWeatherLimits 
                ? html` <div class="weather-limits-overlay">
                    <div class="weather-limits-container">
                        <voyage-custom-weather-limits
                        @cancel=${() => {this._showHeavyWeatherLimits = false}}
                        .isEditView=${this._weatherLimitsEditView}
                        imo=${this._selImo}
                    >  </voyage-custom-weather-limits>
                    </div>
                </div>`
                : ""}
                ${ this._showForecastWarning ? this.renderForecastWarning() : nothing}
                <voyage-map .vesselInTimePosition=${this._vesselInTimePosition} @mapcoord=${this.onMapCoord} @mapcoordmove=${this.onMapCoordMove}></voyage-map>
                ${!this._showHeavyWeatherLimits ? html`<voy-global-search></voy-global-search>` : nothing}
                ${this._showVesselLoader ? html`<div class="spinner"><mc-loading-indicator fit="large" label="${this.loaderText || 'Loading view'}"></mc-loading-indicator></div>` : nothing}
                <div class="panel-button-row">
                    <voy-alert-messages class="alerts-container" imo=${this._currentImoNo}></voy-alert-messages>
                    <voyage-button
                        .focused=${this._showMapViewOptions}
                        ?toggled=${false} @click=${() => this._onMapViewOptionsClick()}>
                        <span class="map-switch-options">Map View</span>
                    </voyage-button>
                    <voyage-button
                        .focused=${this._showGlobalFilters}
                        ?toggled=${false} 
                        @click=${this._onGlobalFiltersClick}>
                        <span class="global-filters">${globalFiltersTitle}</span>
                    </voyage-button>
                    <voyage-button @click=${this._vesselListHandler}
                        .focused=${this._showWeatherBroadcastingDrawer}
                    >
                        <span>List</span>
                    </voyage-button>
                    <voyage-button
                        .focused=${this._showLayersSelector}
                        ?toggled=${false} @click=${() => this._onMapLayerSelectorClick()}>
                        <span class="map-layers">Layers</span>
                    </voyage-button>
                    <voyage-button
                        .focused=${this._showWeather}
                        @click=${() => {this._onWeatherClick(); this.tracingAnalyticsOnClick('Show Weather')}}>
                        <span>Weather</span></voyage-button>
                </div>

                <div class="loading-indicator-container">
                    <voyage-loading-indicator></voyage-loading-indicator>
                </div>
                <!-- right-panel-container this is for enabling the right panel visibility on hovering that area -->
                ${(!this._showFocus && !this._anchored) ? nothing : html`<div class="right-panel-container" @mouseenter = ${()=> UiStateModel!.setLeftPanelVisibility(true) } @mouseleave = ${()=>{if(!this._anchored) UiStateModel!.setLeftPanelVisibility(false)}}>
                    ${this._showLeftPanel ? html`<voy-fleet-sub-view-container timeLineVisible = ${this._showTimeLine}></voy-fleet-sub-view-container>`:nothing}
                 </div>`}
                    <voyage-toggle-box class="info-content" guard-top=54 ?shown=${this._showInfoBox} transparent=true>
                   <voyage-info class="info-content"></voyage-info>
                </voyage-toggle-box>
                <voyage-drawer-panel .triggered=${this.triggered}  .filterResult=${this.filterResult} class="map-view-options-panel" ?showMapViewOptions=${this._showMapViewOptions} ?shown=${this._showMapViewOptions} @filters-changed=${this._updateNumberOfActiveFilters} @close=${() => {this._showMapViewOptions = false}} drawerTitle="Map View" ?showOnTop=${true}>
                    <voyage-map-view-options ?shown=${this._showMapViewOptions} @map-view-option-changed=${this._onMapViewSelectionChangedEvent}></voyage-map-view-options>
                </voyage-drawer-panel>
                <voyage-drawer-panel .triggered=${this.triggered} class="global-filters-panel" ?shown=${this._showGlobalFilters} @filters-changed=${this._updateNumberOfActiveFilters} @close=${() => {this._showGlobalFilters = false}} drawerTitle="Filters" ?showOnTop=${true} .numberOfVessels=${this._numberOfVessels}>
                    <voy-global-filters @close-filter=${this.handleCloseFilter} @filters-changed=${this._updateNumberOfActiveFilters} .shown=${this._showGlobalFilters}></voy-global-filters>
                </voyage-drawer-panel>
                <custom-filter-popup id="customFilterPopup" ?shown="${this.customFilterOpened}" @filters-changed=${this._updateNumberOfActiveFilters} @close="${this._closeCustomFilterPopup}"></custom-filter-popup>
               <fleet-session-expire-popup></fleet-session-expire-popup>
                <voyage-drawer-panel .triggered=${this.triggered} class="weather-panel" ?showWeather=${this._showWeather} ?shown=${this._showWeather} fit="large" .checked=${this.showAdvancedWeather}
                    @close=${() => {this._showWeather = false}} @toggle=${this.handleWeatherToggle} drawerTitle="Weather" ?showOnTop=${true} drawerDesc="" showToggler=${true} togglerLabel="Advance view">
                    <voyage-weather-control .showAdvancedWeather=${this.showAdvancedWeather}></voyage-weather-control>
                </voyage-drawer-panel>
                <voyage-drawer-panel .triggered=${this.triggered} class="performance-overview" ?shown=${this._showPerformance} .showCloseBtn=${true} @close=${() => {this._showPerformance = false}} drawerTitle="Performance">
                    <voyage-performance-overview ?isShown=${this._showPerformance}></voyage-performance-overview>
                </voyage-drawer-panel>
                <voy-weather-broadcast-drawer ?shown=${this._showWeatherBroadcastingDrawer} @close=${() => {this._showWeatherBroadcastingDrawer = false}}></voy-weather-broadcast-drawer>
                ${this.devPanels()}
                <voyage-drawer-panel .triggered=${this.triggered} ?shown=${this._showLayersSelector} @close=${() => {this._showLayersSelector = false}} drawerTitle="Map Layers" ?showOnTop=${true}>
                    <shore-map-layers-selector ?shown=${true} @selection-changed=${this._onLayersSelectionChanged}></shore-map-layers-selector>
                </voyage-drawer-panel>
                <voyage-drawer-panel .triggered=${this.triggered} class="activity-log" ?shown=${this._showActivityLog} .showCloseBtn=${false} @need-action=${(e: any) => this._needAction = e.detail.needAction} @close=${() => {this._showActivityLog = false}} drawerTitle="Activity Log">
                    <voy-activity-log ?isShown=${this._showActivityLog} ?needAction=${this._needAction}></voy-activity-log>
                </voyage-drawer-panel>
                ${this._showTimeLine ? html`<div class="timecontrol">
                    <voyage-time-control id="voyage-time-control"
                                        @playbackrate-update=${(evt: CustomEvent) => this.playbackRateUpdate(evt)}
                                        @toggle-play=${(evt: CustomEvent) => this.togglePlayer(evt)}
                                        @focustime-update=${(evt: CustomEvent) => this.focustimeUpdate(evt)}
                                        .playerTime=${this._playerTime}
                                        .imo=${this._currentImoNo}>
                    </voyage-time-control>
                </div>` : ""}
            </div>
            </voyage-heavy-weather-alarm-limits>
            <voy-chart-depths-control ?shown=${this._showDepthsControl} @close=${() => this._showDepthsControl = false }>
            </voy-chart-depths-control>
            <port-memo-popup ?shown=${this._portMemoShowPopup} terminal-code=${this._portMemoTerminalCode} @close=${() => { this._portMemoShowPopup = false; this._portMemoTerminalCode = ""}}>
            </port-memo-popup>
            <!-- show the weather alarm popup for only VET users -->
            ${showHandleAlarm() ?
                html`
                <voy-weather-alarm-popup 
                @check-more-alarms=${(evt: CustomEvent) => { this._CheckForMoreAlarms(evt.detail)}}
                .alarms=${this._weatherAlarms}
                .alarm=${this._alarm}
                .shown=${this.alarmsCount > 0 && this.isAlarmPopupOpen}
                @close=${() => this.isAlarmPopupOpen = false}>
                </voy-weather-alarm-popup>` : nothing
            }
            <voy-feature-feedback-popup .showCloseIcon=${this.showCloseIcon} .shown=${this._showFeedback} @close=${this.handleClose}></voy-feature-feedback-popup>
            <voy-feature-add-note-popup .shown=${this._showAddNotePopup} .alarm=${this._selectedAlarmForNote} .auditLog=${this._selectedAuditLogForNote} @close=${this.handleCloseAddNote}></voy-feature-add-note-popup>
            <voy-feature-view-notes-popup .shown=${this._showViewNotePopup} .alarm=${this._selectedAlarmForNote} .auditLog=${this._selectedAuditLogForNote} @close=${this.handleCloseViewNote}></voy-feature-view-notes-popup>
            ${this._updateAvailable ? html`<div class="refresh"><a @click=${this.refreshAfterUpdate}>${SvgIcons.solidSync} REFRESH NOW</a></div>` : ''}
            ${this._loggedIn ? '' : html`<voyage-login-overlay ?relogin = ${this._relogin}></voyage-login-overlay>`}
            <voy-toast></voy-toast>
            ${this.hasAlarmAccess ? html`<voy-offline-vessels-popup></voy-offline-vessels-popup>`: null}
        `;
    }

    @property({attribute: false}) private _showVesselDetail: boolean = false;
    @property({attribute: false}) private _currentImoNo: number = 0;
    @property({attribute: false}) private _loggedIn: boolean = false;
    @property({attribute: false}) private _showMapViewOptions: boolean = false;
    @property({attribute: false}) private _showVesselLoader: boolean = false;
    @property({attribute: false}) private _showGlobalFilters: boolean = false;
    @property({attribute: false}) private _showHeavyWeatherLimits: boolean = false;
    @property({attribute: false}) private _showWeather: boolean = false;
    @property({attribute: false}) private _showPerformance: boolean = false;
    @property({attribute: false}) private _showRouteTester: boolean = false;
    @property({attribute: false}) private _showInfoBox: boolean = false;
    @property({attribute: false}) private _playerTime: number = -1;
    @property({attribute: false}) private _vesselInTimePosition: number[]|null = null;
    @property({attribute: false}) private _updateAvailable: boolean = false;
    @property({attribute: false}) private _showDepthsControl: boolean = false;
    @property({attribute: false}) private _voyFleetSubViewEl: Element|null = null;
    @property({attribute: false}) private _weatherBroadcastDrawer: VoyWeatherBroadcastDrawer|null = null;
    @property({attribute: false}) private _portMemoShowPopup: boolean = false;
    @property({attribute: false}) private _portMemoTerminalCode: string = "";
    @property({attribute: false}) private _showLayersSelector: boolean = false;
    @property({attribute: false}) private _numberOfActiveFilters: number = 0;
    @property({attribute: false}) private _showWeatherBroadcastingDrawer: boolean = false;
    @property({attribute: false}) private _relogin: boolean|undefined = false;
    @property({attribute: false}) private _weatherAlarms: Alarm[] = [];
    @property({attribute: false}) private _show: boolean = false;

    @property({attribute: false}) private _numberOfVessels: number = 0;
    @property({attribute: false}) private _showBufferMonitoring: boolean = false;
    @property({attribute: false}) private  _showVoyageSummary: boolean = false;
    @property({attribute: false}) private _showActivityLog : boolean = false;
    @property({attribute: false}) private _selectedAlarmForNote : FleetAlarm | null = null;
    @property({attribute: false}) private _selectedAuditLogForNote : AuditLog | null = null;
    @property({attribute: false}) private _showAddNotePopup : boolean = false;
    @property({attribute: false}) private _showViewNotePopup : boolean = false;
    @property({attribute: false}) private _needAction: boolean = false;
    @property({attribute: false}) private currentZoom: number = 4;
    @property({attribute: false}) private maximized: boolean = false;
    @property({attribute: false}) private showAdvancedWeather: boolean = false;
    @property({attribute: false}) private loaderText?: string;
    @property({attribute: false}) private _weatherLimitsEditView: boolean = false;
    @property({attribute: false}) private _selImo: string = "";
    @property({attribute: false}) private hasAlarmAccess: boolean = AuthService.userHasRole(AuthorizationRoles.AlarmEdit); // VET access 

    private planLayer: PlanLayer|null = null;
    private vesselInTimeLayers: VesselInTimeLayers|null = null;
    private planningLayers: PlanningLayers|null = null;
    private voyageLayers: VoyageLayers|null = null;
    private _restrictedAreasLayer: RestrictedAreasLayer|null = null;
    private _playerCore: Player;
    private _mapElement: VoyageMap|null = null;
    private _voyageInfo: VoyageInfo|null = null;
    private _portAndTerminalLayer: PortAndTerminalLayer|null = null;
    private _nearestPortVizLayer: RulerLayer|null = null;
    private _ecaSecaLayer: EcaSecaLayer|null = null;
    private _marpolLayer: MarpolLayer|null = null;
    private _whaleZonesLayerAll: WhaleZonesLayerAll|null = null;
    private _shoreWhaleZonesLayerInForce: ShoreWhaleZonesLayerInForce|null = null;
    private _securityZones: SecurityZonesLayer | null = null;
    private _terminalGeofences: TerminalGeofenceLayer | null = null;
    private _showTimeLine: boolean = false
    private _showForecastWarning: boolean = false;
 
    private _showLeftPanel: boolean = true;
    private _anchored: boolean = true;
    private _showFocus: boolean = true;
    private _vesselsUpdated: boolean = false;

    devPanels() {
/*START.DEV_ONLY*/
        return html`<voyage-drawer-panel .triggered=${this.triggered} id="route-tester" ?shown=${this._showRouteTester} .showCloseBtn=${true}
            @close=${() => {this._showRouteTester = false}} drawerTitle="Route tester">
            <voyage-routing-tester></voyage-routing-tester>
        </voyage-drawer-panel>`;
/*END.DEV_ONLY*/
        return '';
    }

    async focustimeUpdate(evt: CustomEvent) {
        const focustime = evt.detail.focustime;
        await WeatherModel?._updateForecasts(focustime);
        this._playerCore.currentTime = focustime;
    }

    togglePlayer(evt: CustomEvent) {
        const play = evt.detail.play;
        if (play) {
            this._playerCore.play();
            return;
        }

        this._playerCore.pause();
    }

    playbackRateUpdate(evt: CustomEvent) {
        const playbackrate = evt.detail.playbackrate;
        this._playerCore.playbackRate = playbackrate;
    }

    refreshAfterUpdate() {
        ServiceWorkerReg.checkForUpdate();
        window.location.reload();
    }

    onMapCoordMove(evt: CustomEvent) {
        this._voyageInfo!.handleMove(evt);
    }

    onMapCoord(evt: CustomEvent) {
        this._voyageInfo!.handleClick(evt);
    }

    onVesselSelected(evt: CustomEvent) {
        const currentZoom = this._mapElement?.getMap()?.getView().getZoom();
        if(currentZoom){
            this._mapElement?.getMap()?.getView().setZoom(currentZoom);
        }
        this.applyVesselSelected(evt.detail.value);
    }

    applyVesselSelected(imoNo: number) {
        if (this.planLayer && !imoNo) {
            this.planLayer.clear();
        }
        if (this.vesselInTimeLayers) {
            this.vesselInTimeLayers.clear();
        }

        if (this.voyageLayers && !imoNo) {
            this.voyageLayers!.clearVoyage();
        }
        this._currentImoNo = imoNo ? imoNo : 0;
    }

    async firstUpdated() {
        const authCallback = async () => {
            this._loggedIn = true;

            if (initialized) {
                return;
            }
            initialized = true;

            this._playerTime = this._playerCore.currentTime;
            this._playerCore.addEventListener('timeupdate', () => {
                this._playerTime = this._playerCore.currentTime;
            });

            this.assignModels();
        };
        let initialized = false;
        const authRequired = !!(<any>window)["appenv"].authRequired;

        this._mapElement = <VoyageMap>this.shadowRoot!.querySelector('voyage-map');
        this._voyageInfo = <VoyageInfo>this.shadowRoot!.querySelector('voyage-info');

        this._voyFleetSubViewEl = this.shadowRoot!.querySelector("voy-fleet-sub-view-container");
        this._weatherBroadcastDrawer = this.shadowRoot!.querySelector("voy-weather-broadcast-drawer")
        //need to imporve this - for the timebeing to implement login redirect
        if(localStorage.getItem((<any>window)["appenv"].loginInfo?.accessToken))  {
            if (initialized) {
                return;
            }
            initialized = true;

            this._playerTime = this._playerCore.currentTime;
            this._playerCore.addEventListener('timeupdate', () => {
                this._playerTime = this._playerCore.currentTime;
            });
            this._loggedIn = true;
            AuthService.addEventListener('logged-in', authCallback);
 
            let selectedMapView = UiStateModel!.getValue(UiStateModelParam.SelecteMapView) ?? await UserConfigService.getUserMapView(AuthService.getCurrentUserId()); 
            if(selectedMapView){
                UiStateModel!.setValue(UiStateModelParam.SelecteMapView, selectedMapView);
                this._onMapViewSelectionChanged(selectedMapView);
            }else{
                this.assignModels();
            }
        }   
        else {
            AuthService.dispatchEvent(new Event("login-required") ) 
        }               

        if (!authRequired) {
            authCallback();
        } else {
            AuthService.addEventListener('logged-in', authCallback);
            AuthService.addEventListener('login-required', async (relogin) => {
                this._relogin = (relogin as any)?.detail?.isRelogin;
                this._loggedIn = false;
            });

            if (AuthService.isLoggedIn) {
                authCallback();
            }
        }

        UiStateModel!.addEventListener(`${UiStateModelParam.IMO}-change`, <EventListener>this.onVesselSelected);
        UiStateModel!.addEventListener(`${UiElements.PerformanceGraphs}-toggled`, <EventListener>(() => this._showPerformance = !this._showPerformance));

        let imoSelected = UiStateModel!.getValue(`${UiStateModelParam.IMO}`);
        if(imoSelected) {
            this.applyVesselSelected(parseInt(imoSelected));
        } else {
            imoSelected = UiStateModel!.getValue('imo');
            if(imoSelected) {
                this.applyVesselSelected(parseInt(imoSelected));
            }
        }

        VoyageStyle.addEventListener('styles-changed', () => this.stylesChanged() );

        this.showAdvancedWeather = localStorage.getItem('showAdvancedWeather') === "true";

        Object.keys(sessionStorage)
        .filter(function(key) { return key.includes("warning-coordinates"); })
        .forEach(function(key) {
            sessionStorage.removeItem(key);
        });
    }

    async assignModels(mapConfig:any = {simplified: "true", level: "0"}) {
        const styles = getComputedStyle(this);
        setVoyagePastTrailModel(new VoyagePastTrailModelImpl());
        this.planLayer = new PlanLayer({
            planColor: styles.getPropertyValue('--primary-blue-700'),
            pastTrailColor: styles.getPropertyValue('--primary-blue-700'),
            waypointFillColor: styles.getPropertyValue('--functional-grey-600')
        });
        this.vesselInTimeLayers = new VesselInTimeLayers(this._playerCore);
        this.vesselInTimeLayers.addEventListener('vessel-in-time-position', <EventListener>((evt: CustomEvent) => this._vesselInTimePosition = evt.detail ));
        this.vesselInTimeLayers?.addEventListener('toggle-loader', <EventListener>((evt: CustomEvent) => { this.handleLoaderToggle(evt) }));
        this.vesselInTimeLayers?.addEventListener('past-simulation-limit-reached', <EventListener>((evt: CustomEvent) => { this.handlePastSimulationLimit(evt) }));
        this.vesselInTimeLayers?.addEventListener('toggle-player-controls', <EventListener>((evt: CustomEvent) => { this.togglePlayerControls(evt) }));
        this.voyageLayers = new VoyageLayers(this._playerCore, {
            trackColor: styles.getPropertyValue('--neutrals-grey-03'),
            pastTrailHighlightedMarkerColor: styles.getPropertyValue('--voyage-past-trail-highlighted-marker'),
            pastTrailLineColor: styles.getPropertyValue('--voyage-past-trail-line'),
            pastTrailMarkerColor: styles.getPropertyValue('--voyage-past-trail-marker'),
            highlightCircleColor: styles.getPropertyValue('--vessel-highlight-color'),
            vesselIconAlarmColor: styles.getPropertyValue('--feedback-danger'),
            vesselIconColor: styles.getPropertyValue('--primary-blue-700'),
            positionWarningMarkerWarnColor: styles.getPropertyValue('--position-warning-marker-warn'),
            positionWarningMarkerErrorColor: styles.getPropertyValue('--position-warning-marker-error'),
            nonMaerskVesselIconColor: styles.getPropertyValue('--non-maersk-vessel-icon-color'),
        });
        this._restrictedAreasLayer = new RestrictedAreasLayer({ fillColor: styles.getPropertyValue('--restricted-areas-layer-fill-color'),
                                                                borderColor: styles.getPropertyValue('--restricted-areas-layer-border-color'),
                                                                corridorColor: styles.getPropertyValue('--restricted-areas-layer-corridor-color')});
                                                            
        this.planningLayers = new PlanningLayers();

        this._portAndTerminalLayer = new PortAndTerminalLayer();
        this._nearestPortVizLayer = new RulerLayer({color: styles.getPropertyValue('--neutrals-grey-01'), displayTotals: false});
        this._ecaSecaLayer = new EcaSecaLayer({ fillColor: styles.getPropertyValue('--eca-seca-layer-fill-color'),
            borderColor: styles.getPropertyValue('--eca-seca-layer-border-color')});
        this._marpolLayer = new MarpolLayer({ fillColor: styles.getPropertyValue('--marpol-layer-fill-color'),
            borderColor: styles.getPropertyValue('--marpol-layer-border-color')});
        this._whaleZonesLayerAll = new WhaleZonesLayerAll({ fillColor: styles.getPropertyValue('--whale-zones-layers-fill-color'),
            borderColor: styles.getPropertyValue('--whale-zones-layers-border-color'),
            avoid: styles.getPropertyValue('--whale-zones-layers-avoid-color'),
            restricted: styles.getPropertyValue('--whale-zones-layers-restricted-color')})                                        

        this._shoreWhaleZonesLayerInForce = new ShoreWhaleZonesLayerInForce({ fillColor: styles.getPropertyValue('--whale-zones-layers-fill-color'),
            borderColor: styles.getPropertyValue('--whale-zones-layers-border-color'),
            avoid: styles.getPropertyValue('--whale-zones-layers-avoid-color'),
            restricted: styles.getPropertyValue('--whale-zones-layers-restricted-color')});
        this._securityZones = new SecurityZonesLayer({ fillColor: styles.getPropertyValue('--security-layer-fill-color'),
            borderColor: styles.getPropertyValue('--security-layer-border-color')});
        this._terminalGeofences = new TerminalGeofenceLayer({ fillColor: styles.getPropertyValue('--security-layer-fill-color'),
            borderColor: styles.getPropertyValue('--security-layer-border-color')});
        
        await MgLayers!.initialize(mapConfig);
        await this.planLayer.initialize();
        await this.vesselInTimeLayers.initialize();
        await this.voyageLayers.initialize();
        await this.planningLayers.initialize();
        await this._portAndTerminalLayer.initialize();
        await this._restrictedAreasLayer.initialize();
        await this._ecaSecaLayer.initialize();
        await this._marpolLayer.initialize();
        await this._shoreWhaleZonesLayerInForce.initialize();
        await this._whaleZonesLayerAll.initialize();
        await this._securityZones.initialize();
        await this._terminalGeofences.initialize();

/*START.DEV_ONLY*/
        await DevLayers.initialize();
/*END.DEV_ONLY*/

        // Initialize MeteoGroup map
        this._mapElement!.initMaps(this._playerCore, [
            ...MgLayers!.layers,
            ...this._portAndTerminalLayer.layers,
            this._nearestPortVizLayer.layer!,
            this.planLayer.layer!,
            ...this.voyageLayers.layers,
            ...this.vesselInTimeLayers.layers,
            ...this.planningLayers.layers,
            ...this._restrictedAreasLayer.layers,
            ...this._ecaSecaLayer.layers,
            ...this._marpolLayer.layers,
            ...this._shoreWhaleZonesLayerInForce.layers,
            ...this._whaleZonesLayerAll.layers,
            ...this._securityZones.layers,
            ...this._terminalGeofences.layers,

/*START.DEV_ONLY*/
            ...DevLayers.layers
/*END.DEV_ONLY*/
        ], this.voyageLayers);
        this._mapElement!.routeLayers = [
            ...this._portAndTerminalLayer.layers,
            ...this._restrictedAreasLayer.layers,
            ...this._ecaSecaLayer.layers,
            ...this._marpolLayer.layers,
            ...this._shoreWhaleZonesLayerInForce.layers,
            ...this._whaleZonesLayerAll.layers,
            ...this._securityZones.layers,
            ...this._terminalGeofences.layers,
        ];

        this.voyageLayers.assignMap(this._mapElement!.getMap()!);
        this.vesselInTimeLayers.assignMap(this._mapElement!.getMap()!);
        this._nearestPortVizLayer.assignMap(this._mapElement!.getMap()!);
        this._portAndTerminalLayer.assignMap(this._mapElement!.getMap()!);

        NearestPortModel!.addEventListener(NearestPortEvents.PortHighlightChange, this._updateNearestPortHighlight);
        NearestPortModel!.addEventListener(NearestPortEvents.DropPin, this._nearestPortDropPin);
        this._nearestPortVizLayer.addEventListener('ruler', this._nearestPortRulerUpdate);
        this.addEventListener('show-port-memo', <EventListener>this._showPortMemo);
        this.addEventListener(MapView.AdaptView, this._adjustMapView);
        this._restrictedAreasLayer.enable();
        VoyMapModel!.assignMap(this._mapElement!.getMap()!);
        VoyWeatherBroadcastManager.assignMap(this._mapElement!.getMap()!)
    }

    private handleLoaderToggle(evt: CustomEvent){
        this._showVesselLoader = evt.detail.show;
        this.loaderText = evt.detail.label || '';
    }

    private _updateNumberOfActiveFilters(e: CustomEvent) {
        this._numberOfActiveFilters = e.detail.numberOfActiveFilters;
        this._numberOfVessels = this._numberOfActiveFilters > 0 ? this._numberOfVessels : 0;
    }

    private _openCustomLimits(event:CustomEvent) {
        const { imo, isEditView } = event.detail;
        this._weatherLimitsEditView  =isEditView
        this._selImo = imo;    
        this._showHeavyWeatherLimits = true;
    }

    private _onLayersSelectionChanged(evt: CustomEvent<{layer: ShoreLayers, value: boolean}>) {
        evt.detail.value ? UiStateModel!.setValue(UiStateModelParam.SelectedMapLayer, evt.detail.layer) : UiStateModel!.setValue(UiStateModelParam.SelectedMapLayer, "");

        if (evt.detail.layer === 'ECA/SECA') {
            evt.detail.value ? this._ecaSecaLayer!.enable() : this._ecaSecaLayer!.disable();
            return;
        }

        if (evt.detail.layer === 'Marpol') {
            evt.detail.value ? this._marpolLayer!.enable() : this._marpolLayer!.disable();
            return;
        }

     
        if (evt.detail.layer === 'Whale zones (All)') {
            evt.detail.value ? this._whaleZonesLayerAll!.enable() : this._whaleZonesLayerAll!.disable();
            return;
        }

        if (evt.detail.layer === 'Whale Zones In Force') {
            evt.detail.value ? this._shoreWhaleZonesLayerInForce!.enable() : this._shoreWhaleZonesLayerInForce!.disable();
            return;
        }


        if (evt.detail.layer === 'Security zones') {
            evt.detail.value ? this._securityZones!.enable() : this._securityZones!.disable();
            return;
        }

        if (evt.detail.layer === 'Terminal geofences') {
            evt.detail.value ? this._terminalGeofences!.enable() : this._terminalGeofences!.disable();
            return;
        }

        if(evt.detail.layer === 'Lat Long') {
            this._showInfoBox = evt.detail.value || false;
            this.tracingAnalyticsOnClick('Show InfoBox');
        }
    }

    private _onMapViewSelectionChanged(selectedOption: string) {
        this.assignModels(this._getMapConfig(selectedOption));
    }

    private async _onMapViewSelectionChangedEvent(evt: CustomEvent) {
        evt.preventDefault();
        if(evt.detail.selectedOption !== UiStateModel?.getValue(UiStateModelParam.SelecteMapView)){
            this._resetMap();
            this.assignModels(this._getMapConfig(evt.detail.selectedOption));
            this._showVesselLoader = true;
            VesselsTrackingModel?._processVessels();
        }
    }

    private _getMapConfig(selectedOption: string){
        let mapConfig = {
            simplified: "true",
            level: "0",
        }
        switch (selectedOption) {
            case "simplified":
                mapConfig = {
                    simplified: "true",
                    level: "0",
                }
              break;
            case "basic":
                mapConfig = {
                    simplified: "false",
                    level: "0",
                }
              break;
            case "standard":
                mapConfig = {
                    simplified: "false",
                    level: "1",
                }
              break;
            case "advanced":
                mapConfig = {
                    simplified: "false",
                    level: "2",
                }
              break;
            }
        return mapConfig;
    }

    private _resetMap(){
        this._mapElement?.getMap()?.removeLayer(new Tile({source: new OSM()}));
        this._mapElement?.getMap()?.removeLayer(new Vector({source: new VectorSource()}));
        this._mapElement?.getMap()?.dispose();
    }

    private async _openFeedBackPopup() {
        let currentDate = new Date();
                let username:string = AuthService.getUserDetails();
                let feedBackSubmittedArray = await VoyFleetNotificationModel?.getFeedbackSubmittedHistory()
                let temp: boolean = true;
                feedBackSubmittedArray.map((val:any) =>  {
                    let parsedData = JSON.parse(val.data)
                    if(parsedData.username === username && parsedData.feedbackGivenMonth == currentDate.getMonth()){
                        temp = false;
                    }
                })
                this._showFeedback = temp;
    }
    

    private _vesselListHandler() {
        this._showWeatherBroadcastingDrawer = !this._showWeatherBroadcastingDrawer;
        if (this._showWeatherBroadcastingDrawer) {
            VoyWeatherBroadcastManager!.enterMode();
        } else {
            VoyWeatherBroadcastManager!.exitMode();
            this._weatherBroadcastDrawer!.close()
        }
    }

    private async _checkVersionId() {
        try {
            const newVersionId : VersionId = await authFetchGET((<any>window).appenv.scopes.VOY, "./version.json");

            if (newVersionId) {
                let oldVersionId: VersionId = JSON.parse(localStorage.getItem("version") || "null");
                if (!oldVersionId) {
                    oldVersionId = { version: "" }
                    localStorage.setItem("version", JSON.stringify(newVersionId));
                }
    
                if (newVersionId.version !== oldVersionId.version) {
                    localStorage.setItem("version", JSON.stringify(newVersionId));
                    this._updateAvailable = true;
                    await ServiceWorkerReg.checkForUpdate();
                }
            }
        } catch (error: unknown) {
            console.error("error");
            //AuthService.doAuth(); // Re-authenticate if the auth expired
        }
    }

    private _onMapViewOptionsClick() {
        this._showMapViewOptions = !this._showMapViewOptions;

        if (this._showMapViewOptions) {
            const closeLayersSelector = () => {
                this._showMapViewOptions = false;
            }
            const togglableElement = this.shadowRoot!.querySelector(".map-view-options-panel");
            elementCloseManager.addElement(closeLayersSelector, this, togglableElement!);
        }
    }

    private _onGlobalFiltersClick() {
        this._showGlobalFilters = !this._showGlobalFilters;
        if (this._showGlobalFilters) {
            const closeLayersSelector = () => {
                this._showGlobalFilters = false;
            }
            const togglableElement = this.shadowRoot!.querySelector(".global-filters-panel");
            elementCloseManager.addElement(closeLayersSelector, this, togglableElement!);
        }
    }

    private _onMapLayerSelectorClick() {
        this._showLayersSelector = !this._showLayersSelector;

        if (this._showLayersSelector) {
            const closeLayersSelector = () => {
                this._showLayersSelector = false;
            }
            const togglableElement = this.shadowRoot!.querySelector("shore-map-layers-selector");
            elementCloseManager.addElement(closeLayersSelector, this, togglableElement!);
        }
    }

    private _onWeatherClick() {
        this._showWeather = !this._showWeather;

        if (this._showWeather) {
            const closeWeather = () => {
                this._showWeather = false;
            }
            const togglableElement = this.shadowRoot!.querySelector(".weather-panel");
            elementCloseManager.addElement(closeWeather, this, togglableElement!);
        }
    }

    private _onRouteTesterClick() {
        this._showRouteTester = !this._showRouteTester;
        if (this._showRouteTester) {
            const closeRouteTester = () => {
                this._showRouteTester = false;
            }
            const togglableElement = this.shadowRoot!.querySelector("#route-tester");
            elementCloseManager.addElement(closeRouteTester, this, togglableElement!);
        }
    }

    private _updateNearestPortHighlight(evt: Event) {
        const { detail } = evt as CustomEvent;
        const { ports } = <NearestPortHighlights>detail;
        this._portAndTerminalLayer?.updatePortHighlights(ports);
    }
    
    private _nearestPortRulerUpdate(evt: Event) {
        const { detail } = evt as CustomEvent;
        const rulerDetails = detail as RulerUpdateDetails;
        NearestPortModel?.updateRuler(rulerDetails);
    }

    private _nearestPortDropPin(evt: Event) {
        const { detail } = evt as CustomEvent;
        const { position } = <NearestPortPosition>detail;
        if (position) {
            if (Array.isArray(position[0])) {
                // pre-created route from vessel to port
                this._nearestPortVizLayer?.setStartRoute(<number[][]>position);
            } else {
                // custom route in editing mode
                this._nearestPortVizLayer?.setStart(<number[]>position);
            }
            
            if (!this._nearestPortVizLayer?.layer?.getVisible()) {
                this._nearestPortVizLayer?.addInteractions({ruler: false});
            }
        } else {
            if (this._nearestPortVizLayer?.layer?.getVisible()) {
                this._nearestPortVizLayer?.removeInteractions();
            }
        }
    }

    private _adjustMapView(evt: Event) {
        // for defining box, we need to modify box lines crossing the dateline so point 'train' is continuous.
        const continousLon = (lon1: number, lon2: number) => {
            if (Math.abs(lon2 - lon1) > 180) {
                return lon2 + Math.sign(lon1) * 360;
            }
            return lon2;
        }
        const { detail } = evt as CustomEvent;
        const coords = detail as number[][];
        // input coordinates in EPSG:4326 / WGS84
        const extent = OLExtent.boundingExtent(coords.map((c) => {
            let lastLon: number = coords[0][0];
            let coord = c;
            lastLon = continousLon(lastLon, coord[0]);
            coord = [lastLon, coord[1]];
            return fromLonLat(coord, _PROJECTION);
        }));
        this._mapElement?.getMap()?.getView().fit(OLExtent.buffer(extent, 2000), { duration: 250, padding: [0,0,0,200] });
    }

    private _showPortMemo(evt: CustomEvent) {
        this._portMemoTerminalCode = evt.detail.terminalCode;
        this._portMemoShowPopup = true;
    }

    private _updateVesselsCount(){
        this._numberOfVessels = this._numberOfActiveFilters > 0 ? VoyageShoreContextModel!.vessels.length : 0;
        let timeControl = <VoyageTimeControl>this.shadowRoot?.querySelector("#voyage-time-control");
        if(this._numberOfActiveFilters){
            this.vesselInTimeLayers?._setVessels(this._showTimeLine);
            if(this._playerTime <= (new Date().getTime())){
                timeControl?.toggleStep("backward", true);
            }
        }else{
            this.vesselInTimeLayers?._resetVessels();  
            timeControl?.toggleStep("backward", false);
        }
    }

    private _toggleTimeLine(){
        this._showTimeLine = !this._showTimeLine;
        let element = <HTMLDivElement>this._mapElement?.shadowRoot?.querySelector("voyage-ol-map")?.shadowRoot?.querySelector(".ol-scale-line");
        if(element){
            element.style.bottom = this._showTimeLine ? "50px" : "15px";
        }
        if(this._showTimeLine){
            this.vesselInTimeLayers?.plotInitialPosition(this._playerTime);
        }else{
            this.vesselInTimeLayers?.clearPositions();
        }
        this.requestUpdate();
    }

    private _togglePanelView(visibility:boolean){
        this._showLeftPanel = visibility;
        this.requestUpdate()
    }

    _openCustomFilterPopup() {
        this.customFilterOpened = true;
        this.requestUpdate();
    }

    _closeCustomFilterPopup() {
        this.customFilterOpened = false;
        this.requestUpdate();
    }

    private _handleFilterSaved(event: CustomEvent) {
        const { message, type } = event.detail;
        this._showToast(message, type);
    }
    
    private _showToast(message: string, type: string) {
        const toastElement = this.shadowRoot?.querySelector('voy-toast') as any;
        if (toastElement) {
          toastElement.show(message, type);
        }
    }

    private handlePastSimulationLimit(evt: CustomEvent){
        let timeControl = <VoyageTimeControl>this.shadowRoot?.querySelector("#voyage-time-control");
        timeControl?.toggleStep("backward", evt?.detail?.disableBackward);   

    }

    private togglePlayerControls(evt: CustomEvent){
        let timeControl = <VoyageTimeControl>this.shadowRoot?.querySelector("#voyage-time-control");
        timeControl?.togglePlayerControls(evt?.detail?.disable);   
    }

    private showForecastWarning(){
        const lastForecastWarningTime = JSON.parse(localStorage.getItem('lastForecastWarningTime') || 'null');
        if(!lastForecastWarningTime){
            this._showForecastWarning = true;
            return;
        }
        const lastWarningTimeStamp =  lastForecastWarningTime ?  new Date(lastForecastWarningTime) : new Date();
        const dateNow = new Date();
        const warningUpdatedHours = Math.round(Math.abs(lastWarningTimeStamp.getTime() - dateNow.getTime())/(60*60*1000));
        if(warningUpdatedHours >= 24){
            this._showForecastWarning = true;
        }

    }

    private renderForecastWarning() {
        return html`
          <mc-modal
            ?open=${this._showForecastWarning}
            dimension="small"
            width="525px"
            height="200px"
            backdropcloseactiondisabled
            escapecloseactiondisabled
            entercloseactiondisabled
            hiddenclose
          >
            <span slot="heading"><span class="forecast-heading">Weather forecast outdated |  <span class="forecast-heading-date">${getFormattedDateUTC(new Date())}</span></span></span>
            <div class="forecast-message">Weather Forecast Service Provider (DTN) is currently unavailable. Last forecast received on ${getFormattedDateUTC(new Date(WeatherModel?.latestForecastInfo?.timestamp || ''))}. Please consult an alternative service provider.</div>
            <mc-button
                slot="primaryAction"
                appearance="primary"
                @click="${this.acceptForecastWarning}"
                >Accept</mc-button
              >
          </mc-modal>
        `;
      }

    private acceptForecastWarning(){
        this._showForecastWarning = false;
        localStorage.setItem('lastForecastWarningTime', JSON.stringify(new Date()));
        this.requestUpdate();
    }


    stylesChanged() {
        const styles = getComputedStyle(this);

        this.planLayer!.setColors({
            planColor: styles.getPropertyValue('--primary-blue-700'),
            pastTrailColor: styles.getPropertyValue('--primary-blue-700'),
            waypointFillColor: styles.getPropertyValue('--functional-grey-600')
        });
        this.voyageLayers!.setColors({
            trackColor: styles.getPropertyValue('--neutrals-grey-03'),
            pastTrailHighlightedMarkerColor: styles.getPropertyValue('--voyage-past-trail-highlighted-marker'),
            pastTrailLineColor: styles.getPropertyValue('--voyage-past-trail-line'),
            pastTrailMarkerColor: styles.getPropertyValue('--voyage-past-trail-marker'),
            highlightCircleColor: styles.getPropertyValue('--vessel-highlight-color'),
            vesselIconAlarmColor: styles.getPropertyValue('--feedback-danger'),
            vesselIconColor: styles.getPropertyValue('--primary-blue-700'),
            positionWarningMarkerWarnColor: styles.getPropertyValue('--position-warning-marker-warn'),
            positionWarningMarkerErrorColor: styles.getPropertyValue('--position-warning-marker-error'),
            nonMaerskVesselIconColor: styles.getPropertyValue('--non-maersk-vessel-icon-color'),
        });
        this._nearestPortVizLayer!.setColor('--neutrals-grey-01');
        this._restrictedAreasLayer!.setColors({ fillColor: styles.getPropertyValue('--restricted-areas-layer-fill-color'),
                                                borderColor: styles.getPropertyValue('--restricted-areas-layer-border-color'),
                                                corridorColor: styles.getPropertyValue('--restricted-areas-layer-corridor-color')});
    }
}
